import React from "react";
import { URLImgFront } from '../../../../config/URLDB';
import { ProductosCampania_, RegistroRedencion_ } from '../../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import DetalleModal from '../Coopenautas/DetalleModal';
import CarritoRedencion from '../Coopenautas/CarritoRedencion';
import Loading from '../../../Loading';
import ReactDOM from 'react-dom';

class TiendaPremios extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            productos: [],
            mostrarDetalle: false,
            productoSeleccionado: null,
            estadoLoading: false,
            mostrarCarrito: false,
            carrito: [],
        };
    }

    componentDidMount() {
        this.ConsultaProducto(10, 0, 0, 36, this.props.nivelaso)
    }

    ConsultaProducto = (filtro, redencion, categoria, idconfigcampania, nivelaso = 0) => {
        const body = {
            tran: filtro,
            idredencion: redencion,
            idcategoria: categoria,
            idconfigcampania: idconfigcampania,
            nivelaso: nivelaso
        };

        this.setState({
            estadoLoading: true
        });

        return ProductosCampania_(body).then(response => {
            try {
                const { data } = response;
                if (data.length > 0 && data[0]?.codresp !== 4404) {
                    const productosOptions = data.map(item => ({
                        idredencion: item.idredencion,
                        descredencion: item.descredencion,
                        valor: item.valor,
                        img: item.rutaimgprod,
                        descripcion: item.descripcion,
                        color: item.color,
                        material: item.material,
                        categoria: item.idcategoria,
                        cantidad: item.cantidaddisponible,
                        cantidadpermitida: item.cantidadpermitida
                    }));

                    if (filtro === 9) {
                        this.setState({
                            productoSeleccionado: productosOptions[0],
                        });
                    } else {
                        this.setState({
                            productos: productosOptions,
                            filtro: filtro === 8 ? !this.state.filtro : this.state.filtro
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: data[0]?.codresp === 4404
                            ? 'No se encontró información de los productos!'
                            : 'Ocurrio un error!'
                    });
                    this.props.mostrarPanel(1);
                }
            }
            catch (error) {
                this.setState({ error: error.toString() });
            } finally {
                this.setState({ estadoLoading: false });
            }
        })
    }

    abrirDetalle = (idproducto) => {
        this.ConsultaProducto(9, idproducto, 0, 36)
        document.body.style.overflow = 'hidden';
        this.setState({
            mostrarDetalle: true
        });
    };

    cerrarModal = () => {
        document.body.style.overflow = 'unset';
        this.setState({ mostrarDetalle: false, productoSeleccionado: null });
    };

    redimirAhora = () => {
        const { productoSeleccionado, carrito } = this.state;
        const existe = carrito.find(p => p.idredencion === productoSeleccionado.idredencion);

        const body = {
            tran: 1,
            idconfigcampania: 36,
            periodo: 0,
            id_cliente: this.props.idcliente,
            idredencion: productoSeleccionado.idredencion,
            estado: 1,
        }
        if (existe) {

            if (existe.cantidad >= productoSeleccionado.cantidadpermitida) {
                Swal.fire({
                    icon: 'warning',
                    title: '¡No puedes redimir mas unidades de este artículo!'
                });
                document.body.style.overflow = 'unset';
                this.setState({ mostrarDetalle: false, mostrarCarrito: true, productoSeleccionado: null });
                return;
            }
            RegistroRedencion_(body).then(result => {
                if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                    try {
                        document.body.style.overflow = 'unset';
                        this.setState({
                            carrito: carrito.map(p =>
                                p.idredencion === productoSeleccionado.idredencion
                                    ? { ...p, cantidad: p.cantidad + 1 }
                                    : p
                            ),
                            mostrarDetalle: false, productoSeleccionado: null, mostrarCarrito: true,
                        });
                    } catch (error) {
                        Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                    }
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
            });
        } else {
            RegistroRedencion_(body).then(result => {
                if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                    try {
                        document.body.style.overflow = 'unset';
                        this.setState({
                            carrito: [...carrito, { ...productoSeleccionado, cantidad: 1 }],
                            mostrarDetalle: false, productoSeleccionado: null, mostrarCarrito: true,
                        });
                    } catch (error) {
                        Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                    }
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
            });
        }
    };

    onCambiarCantidad = (idredencion, nuevaCantidad) => {
        const body = {
            tran: 6,
            idconfigcampania: 36,
            periodo: 0,
            id_cliente: this.props.idcliente,
            idredencion: idredencion,
            estado: 1,
        }
        RegistroRedencion_(body).then(result => {
            if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                try {
                    this.setState(({ carrito }) => {
                        const nuevoCarrito = carrito
                            .map((item) =>
                                item.idredencion === idredencion
                                    ? { ...item, cantidad: Math.max(nuevaCantidad, 0) }
                                    : item
                            )
                            .filter((item) => item.cantidad > 0);
                        return {
                            carrito: nuevoCarrito,
                            mostrarCarrito: nuevoCarrito <= 0 ? false : true
                        };

                    });
                } catch (error) {
                    Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                }
            }
        }).catch(err => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
        });
    };

    render() {
        return (
            <>
                {this.state.mostrarCarrito ? (<CarritoRedencion carrito={this.state.carrito} mostrarConsulta={this.props.mostrarConsulta} onVolver={() => this.setState({ mostrarCarrito: false, carrito: [] })} mostrarPanel={this.props.mostrarPanel} onCambiarCantidad={this.onCambiarCantidad} idcliente={this.props.idcliente} nombre={this.props.nomcom} correo={this.props.correo} telcel={this.props.telcel} nit={this.props.nit} tipoiden={this.props.tipoiden} />) :
                    <div className="w-100 h-100 position-relative" data-aos="fade-up" data-aos-delay="3240">
                        <div className="d-flex justify-content-center align-items-center py-2 px-2 mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="3240">
                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/PremiosParaRedimir.svg`} alt="Texto Premios" style={{ maxWidth: '1000px' }}></img>
                        </div>
                        <div data-aos="fade-left" className="mt-4 row px-2 px-md-3 px-lg-5" data-aos-delay="3240">
                            <div className="col d-flex justify-content-center w-100">
                                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 w-75 px-2">
                                    {this.state.productos.map((p) => (
                                        <div className="col mb-4" key={p.idredencion}>
                                            <div className="planestimulos-premios-card">
                                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas${p.img}`} alt={p.descredencion} />
                                                <div style={{ color: '#059B4E' }}>
                                                    {p.descredencion}
                                                </div>
                                                <div className="font-weight-bold font-italic mb-2" style={{ fontSize: '16px', color: '#555' }} >
                                                    {p.valor} puntos
                                                </div>
                                                <button className="planestimulos-btn-detalles" onClick={() => this.abrirDetalle(p.idredencion)}>Detalles</button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {this.state.estadoLoading && (
                            ReactDOM.createPortal(
                                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999999999, backgroundColor: 'rgba(0,0,0,0.4)', overflowY: 'auto', paddingTop: '120px' }} className="d-flex align-items-start align-items-md-center justify-content-center" >
                                    <div style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', overflow: 'hidden', zIndex: 99999999 }}>
                                        <Loading alto={'100%'} />
                                    </div>
                                </div>,
                                document.body)
                        )}
                    </div>
                }

                {this.state.mostrarDetalle && (<DetalleModal producto={this.state.productoSeleccionado} onClose={this.cerrarModal} onRedimir={this.redimirAhora} puntos={this.props.puntos} />)}
            </>
        );
    }
}

export default TiendaPremios;